/**
 * @generated SignedSource<<9eefec7ebef163dfaadedaece59b205e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AutomationsToggleConfigurationMutation$variables = {
  configurationId: string;
};
export type AutomationsToggleConfigurationMutation$data = {
  readonly toggleAutomationConfiguration: {
    readonly configuration: {
      readonly id: string;
      readonly isActive: boolean;
      readonly stream: {
        readonly hasAnyAutomationActive: boolean;
        readonly id: string;
        readonly schedulingMeetingAssistantAutomationIsActive: boolean;
      };
    };
  } | null;
};
export type AutomationsToggleConfigurationMutation = {
  response: AutomationsToggleConfigurationMutation$data;
  variables: AutomationsToggleConfigurationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "configurationId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "configurationId",
        "variableName": "configurationId"
      }
    ],
    "concreteType": "ToggleAutomationConfiguration",
    "kind": "LinkedField",
    "name": "toggleAutomationConfiguration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AutomationConfigurationNode",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasAnyAutomationActive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "schedulingMeetingAssistantAutomationIsActive",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AutomationsToggleConfigurationMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AutomationsToggleConfigurationMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "717f87a7cc357050a59394dccc57d92a",
    "id": null,
    "metadata": {},
    "name": "AutomationsToggleConfigurationMutation",
    "operationKind": "mutation",
    "text": "mutation AutomationsToggleConfigurationMutation(\n  $configurationId: ID!\n) {\n  toggleAutomationConfiguration(configurationId: $configurationId) {\n    configuration {\n      id\n      isActive\n      stream {\n        id\n        hasAnyAutomationActive\n        schedulingMeetingAssistantAutomationIsActive\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7f8afa6c7407bb87ee12af917cac9973";

export default node;
